import { clsx } from 'clsx';
import Link from 'next/link';
import { LuChevronRight } from 'react-icons/lu';
type PodBgColour = 'blue' | 'yellow' | 'orange' | 'red';

interface StudentPodProps {
  className?: string;
  title: string;
  bgColor?: PodBgColour;
  accessory?: React.ReactNode;
  alignAccessory?: 'top' | 'middle' | 'bottom';
  cta?: React.ReactNode;
  to: string;
}

export const StudentPod = ({
  className,
  title,
  bgColor = 'blue',
  accessory,
  alignAccessory = 'middle',
  cta,
  to,
}: StudentPodProps) => (
  <Link
    className={clsx(
      'flex relative rounded-2xl overflow-hidden shadow-xl hover:shadow-none active:shadow-xl',
      bgColor === 'blue' && 'bg-pt-endeavour',
      bgColor === 'yellow' && 'bg-pt-lightening-yellow',
      bgColor === 'orange' && 'bg-pt-trinidad',
      bgColor === 'red' && 'bg-pt-coral-red',
      className,
    )}
    href={to}
  >
    {accessory && (
      <div
        className={clsx(
          'flex flex-col h-full flex-1',
          alignAccessory === 'top' && 'justify-start',
          alignAccessory === 'middle' && 'justify-center',
          alignAccessory === 'bottom' && 'justify-end',
        )}
      >
        {accessory}
      </div>
    )}

    <div className="flex flex-col justify-center items-center gap-6 h-full p-6 flex-1">
      <h2 className="text-xl lg:text-4xl font-black text-white">{title}</h2>

      {cta ? (
        cta
      ) : (
        <span
          className={clsx(
            'flex justify-center items-center w-24 h-24 rounded-full bg-white text-6xl',
            bgColor === 'blue' && 'text-pt-endeavour',
            bgColor === 'yellow' && 'text-pt-lightening-yellow',
            bgColor === 'orange' && 'text-pt-trinidad',
            bgColor === 'red' && 'text-pt-coral-red',
          )}
        >
          <LuChevronRight />
        </span>
      )}
    </div>
  </Link>
);
